module.exports = __webpack_public_path__ + "media/src/img/progr-mob-ffac4573cde48fbce2ede97ee40e7d6e.svg";